import Pagination from "rc-pagination";
import "assets/styles/mixins/BOPagination.scss";
import PropTypes from "prop-types";

export default function BoPagination({ total = 0, page, limit, onChange }) {
  return (
    <>
      <Pagination
        current={page}
        pageSize={limit}
        onChange={(e) => onChange(e)}
        showTotal={(data) => `Total ${data} items`}
        total={total}
      />
      <br />
    </>
  );
}

BoPagination.propTypes = {
  total: PropTypes.number,
  page: PropTypes.number,
  limit: PropTypes.number,
  onChange: PropTypes.func,
};
